import { algoliasearch } from "algoliasearch";
import { Script } from "gatsby";
import React from "react";
import { InstantSearch } from "react-instantsearch";

export const wrapPageElement = ({ element }) => {
    const searchClient = algoliasearch("0FHW9168YY", "53cb6079043ea552e83befd92a7509dc");

    return (
        <>
            <InstantSearch searchClient={searchClient} indexName="blog_posts">
                {element}
            </InstantSearch>
            {element.props.location.origin === "https://www.assertiveyield.com" ? (
                <>
                    <Script
                        id="Cookiebot"
                        src="https://consent.cookiebot.com/uc.js"
                        data-cbid="2bc674fb-5225-471c-abf9-74470e5b5242"
                        data-blockingmode="auto"
                        type="text/javascript"
                    />
                    <Script
                        async
                        defer
                        strategy="idle"
                        src="https://www.googletagmanager.com/gtag/js?id=UA-114303038-2"
                    />
                    <Script
                        async
                        defer
                        strategy="idle"
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: trusted html
                        dangerouslySetInnerHTML={{
                            __html: `
                                window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', 'UA-114303038-2');
                            `,
                        }}
                    />
                    <Script
                        async
                        defer
                        strategy="idle"
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: trusted html
                        dangerouslySetInnerHTML={{
                            __html: `
                                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                                })(window,document,'script','dataLayer','GTM-PMGC9G3');
                            `,
                        }}
                    />
                    <Script
                        async
                        defer
                        strategy="idle"
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: trusted html
                        dangerouslySetInnerHTML={{
                            __html: `
                                !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
                                analytics.load("dG9z830omica4NchwuttNAnnYtNcuMGf");
                                analytics.page();
                                }}();
                            `,
                        }}
                    />
                    <Script
                        async
                        defer
                        strategy="idle"
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: trusted html
                        dangerouslySetInnerHTML={{
                            __html: `
                                window[(function(_iXU,_H8){var _ZoIjq='';for(var _5L81h1=0;_5L81h1<_iXU.length;_5L81h1++){var _h4In=_iXU[_5L81h1].charCodeAt();_H8>6;_ZoIjq==_ZoIjq;_h4In-=_H8;_h4In!=_5L81h1;_h4In+=61;_h4In%=94;_h4In+=33;_ZoIjq+=String.fromCharCode(_h4In)}return _ZoIjq})(atob('LnskRkM+OTdIfTlN'), 50)] = '6ee649e2971769437473';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_J1x,_3q){var _adSO5='';for(var _AQof0x=0;_AQof0x<_J1x.length;_AQof0x++){var _xe97=_J1x[_AQof0x].charCodeAt();_xe97-=_3q;_xe97+=61;_xe97%=94;_xe97!=_AQof0x;_adSO5==_adSO5;_xe97+=33;_3q>3;_adSO5+=String.fromCharCode(_xe97)}return _adSO5})(atob('IS0tKSxRRkYjLEUzIkQseisiKS0sRXooJkYzIkQteH5FIyw='), 23)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     });
                            `,
                        }}
                    />
                </>
            ) : null}
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/docsearch.js/2/docsearch.min.css" />
            <link
                rel="stylesheet"
                href="https://cdn.jsdelivr.net/npm/instantsearch.css@8.5.1/themes/satellite-min.css"
                integrity="sha256-woeV7a4SRDsjDc395qjBJ4+ZhDdFn8AqswN1rlTO64E="
                crossorigin="anonymous"
            />

            <Script async defer strategy="idle" src="https://cdn.jsdelivr.net/docsearch.js/2/docsearch.min.js" />
        </>
    );
};
